import React, {useEffect, useState} from "react";
import {useParams, useNavigate} from "react-router-dom";
import axios from "axios";
import ColorSwatch from "../../components/ColorSwatch";
import "./ShippingLabel.css";

// Your store details — update these.
const STORE = {
  name: "Variant Exclusive",
  gstin: "YOUR_GSTIN_HERE",
  pan: "YOUR_PAN_HERE",
  address: "Your Address Line 1, City, State — Pincode",
  phone: "+91 XXXXXXXXXX",
  email: "variantexclusive@gmail.com",
  website: "variantexclusive.com",
};

export default function ShippingLabel() {
  const {orderNumber} = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`/api/orders/${orderNumber}`)
      .then((r) => {
        setOrder(r.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        navigate("/admin/orders");
      });
  }, [orderNumber, navigate]);
  function handlePrint() {
    window.print();
  }

  if (loading)
    return <div style={{padding: 40, textAlign: "center"}}>Loading…</div>;
  if (!order) return null;

  const addr = order.shippingAddress;
  const today = new Date().toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  const itemCount = order.items?.reduce((s, i) => s + i.quantity, 0) || 0;

  return (
    <div className="sl-page">
      {/* Print controls — hidden when printing */}
      <div className="sl-controls no-print">
        <button
          className="sl-btn-back"
          onClick={() => navigate("/admin/orders")}
        >
          ← Back to Orders
        </button>
        <button className="sl-btn-print" onClick={handlePrint}>
          🖨️ Print / Save as PDF
        </button>
      </div>

      {/* ── Shipping Label ── */}
      <div className="sl-label">
        {/* Header */}
        <div className="sl-header">
          <div className="sl-header-left">
            <div className="sl-store-name">{STORE.name}</div>
            <div className="sl-doc-type">Shipping Label / Tax Invoice</div>
          </div>
          <div className="sl-header-right">
            <div className="sl-order-num">{order.orderNumber}</div>
            <div className="sl-date">Date: {today}</div>
          </div>
        </div>

        {/* Divider */}
        <div className="sl-divider" />

        {/* Address section */}
        <div className="sl-addresses">
          {/* From */}
          <div className="sl-addr-block">
            <div className="sl-addr-label">FROM (Seller)</div>
            <div className="sl-addr-name">{STORE.name}</div>
            {/* <div className="sl-addr-text">{STORE.address}</div> */}
            {/* <div className="sl-addr-text">📞 {STORE.phone}</div> */}
            {/* {STORE.gstin && (
              <div className="sl-addr-text">GSTIN: {STORE.gstin}</div>
            )} */}
          </div>

          {/* Arrow */}
          <div className="sl-arrow">→</div>

          {/* To */}
          <div className="sl-addr-block to">
            <div className="sl-addr-label">TO (Recipient)</div>
            <div className="sl-addr-name">{addr.name}</div>
            <div className="sl-addr-text">{addr.addressLine1}</div>
            {addr.addressLine2 && (
              <div className="sl-addr-text">{addr.addressLine2}</div>
            )}
            <div className="sl-addr-text">
              {addr.city}, {addr.state}
            </div>
            <div className="sl-addr-pincode">PIN: {addr.pincode}</div>
            <div className="sl-addr-text">📞 {addr.phone}</div>
          </div>
        </div>

        <div className="sl-divider" />

        {/* Items table */}
        <table className="sl-table">
          <thead>
            <tr>
              <th style={{width: "5%", fontSize: 16, fontWeight: "bolder"}}>
                Sr.
              </th>
              <th style={{width: "50%", fontSize: 16, fontWeight: "bolder"}}>
                Description
              </th>
              <th style={{width: "10%", fontSize: 16, fontWeight: "bolder"}}>
                Qty
              </th>
              <th style={{width: "15%", fontSize: 16, fontWeight: "bolder"}}>
                Unit Price
              </th>
              <th style={{width: "20%", fontSize: 16, fontWeight: "bolder"}}>
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            {order.items?.map((item, i) => (
              <tr key={i}>
                <td
                  className="sl-td-center"
                  style={{fontSize: 16, fontWeight: "bolder"}}
                >
                  {i + 1}
                </td>
                <td style={{fontSize: 16, fontWeight: "bolder"}}>
                  {item.name}
                  {item.customName && <div>Name: {item.customName}</div>}
                  {item.color && (
                    <div>
                      Colour: <ColorSwatch color={item.color} />
                    </div>
                  )}
                </td>
                <td
                  className="sl-td-center"
                  style={{fontSize: 16, fontWeight: "bolder"}}
                >
                  {item.quantity}
                </td>
                <td
                  className="sl-td-right"
                  style={{fontSize: 16, fontWeight: "bolder"}}
                >
                  Rs. {item.price?.toLocaleString("en-IN")}
                </td>
                <td
                  className="sl-td-right"
                  style={{fontSize: 16, fontWeight: "bolder"}}
                >
                  Rs. {(item.price * item.quantity)?.toLocaleString("en-IN")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="sl-divider" />

        {/* Totals */}
        <div className="sl-totals">
          <div className="sl-total-row">
            <span style={{fontSize: 16, fontWeight: "bolder"}}>Subtotal</span>
            <span style={{fontSize: 16, fontWeight: "bolder"}}>
              Rs. {order.subtotal?.toLocaleString("en-IN")}
            </span>
          </div>
          <div className="sl-total-row">
            <span style={{fontSize: 16, fontWeight: "bolder"}}>Shipping</span>
            <span style={{fontSize: 16, fontWeight: "bolder"}}>
              {order.shippingFee === 0 ? "FREE" : `Rs. ${order.shippingFee}`}
            </span>
          </div>
          {order.discount > 0 && (
            <div className="sl-total-row">
              <span style={{fontSize: 16, fontWeight: "bolder"}}>
                Discount (10%)
              </span>
              <span style={{fontSize: 16, fontWeight: "bolder"}}>
                - Rs. {order.discount.toLocaleString("en-IN")}
              </span>
            </div>
          )}
          {order.couponDiscount > 0 && (
            <div className="sl-total-row">
              <span style={{fontSize: 16, fontWeight: "bolder"}}>
                Coupon {order.couponCode} ({order.couponPercent}%)
              </span>
              <span style={{fontSize: 16, fontWeight: "bolder"}}>
                - Rs. {order.couponDiscount.toLocaleString("en-IN")}
              </span>
            </div>
          )}
          {order.codFee > 0 && (
            <div className="sl-total-row">
              <span style={{fontSize: 16, fontWeight: "bolder"}}>
                COD Charges
              </span>
              <span style={{fontSize: 16, fontWeight: "bolder"}}>
                Rs. {order.codFee}
              </span>
            </div>
          )}
          {order.freeGift && (
            <div className="sl-total-row">
              <span style={{fontSize: 16, fontWeight: "bolder"}}>
                Surprise Gift
              </span>
              <span style={{fontSize: 16, fontWeight: "bolder"}}>FREE</span>
            </div>
          )}
          <div className="sl-total-row grand">
            <span>TOTAL</span>
            <span>Rs. {order.total?.toLocaleString("en-IN")}</span>
          </div>
          <div className="sl-amount-words">
            Amount in Words:{" "}
            <strong>{numberToWords(order.total)} Rupees Only</strong>
          </div>
        </div>

        <div className="sl-divider" />

        {/* Footer info */}
        <div className="sl-footer">
          <div className="sl-footer-left">
            <div className="sl-footer-row">
              <span style={{fontSize: 15, fontWeight: "bolder"}}>Payment:</span>
              <span
                style={{
                  textTransform: "capitalize",
                  fontSize: 16,
                  fontWeight: "bolder",
                }}
              >
                {order.paymentMethod === "cod"
                  ? "Cash on Delivery"
                  : `Online — ${order.paymentStatus}`}
              </span>
            </div>
            <div className="sl-footer-row">
              <span style={{fontSize: 15, fontWeight: "bolder"}}>Items:</span>
              <span style={{fontSize: 15, fontWeight: "bolder"}}>
                {itemCount} item{itemCount !== 1 ? "s" : ""}
              </span>
            </div>
            <div className="sl-footer-row">
              <span style={{fontSize: 15, fontWeight: "bolder"}}>
                Order Status:
              </span>
              <span
                style={{
                  textTransform: "capitalize",
                  fontSize: 15,
                  fontWeight: "bolder",
                }}
              >
                {order.orderStatus}
              </span>
            </div>
          </div>

          {/* <div className="sl-signature-box">
            <div className="sl-sig-line" />
            <div className="sl-sig-label">For {STORE.name}</div>
            <div className="sl-sig-sub">Authorized Signatory</div>
          </div> */}
        </div>

        {/* Barcode-style order number at bottom */}
        <div className="sl-barcode-section">
          <div className="sl-barcode-text">{order.orderNumber}</div>
          <div className="sl-barcode-sub">{STORE.website}</div>
        </div>
      </div>
    </div>
  );
}

// Simple number to words converter for Indian amounts
function numberToWords(num) {
  if (!num) return "Zero";
  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  function convert(n) {
    if (n < 20) return ones[n];
    if (n < 100)
      return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
    if (n < 1000)
      return (
        ones[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 ? " " + convert(n % 100) : "")
      );
    if (n < 100000)
      return (
        convert(Math.floor(n / 1000)) +
        " Thousand" +
        (n % 1000 ? " " + convert(n % 1000) : "")
      );
    if (n < 10000000)
      return (
        convert(Math.floor(n / 100000)) +
        " Lakh" +
        (n % 100000 ? " " + convert(n % 100000) : "")
      );
    return (
      convert(Math.floor(n / 10000000)) +
      " Crore" +
      (n % 10000000 ? " " + convert(n % 10000000) : "")
    );
  }

  const rupees = Math.floor(num);
  return convert(rupees) || "Zero";
}
